
// Archivo generado automáticamente por el pipeline


export const API_URL='https://search.amxinfra.com/api/unotv/';
export const API_TOKEN='https://api.amxinfra.com/agentcore/token';
export const PATHURLDOMAIN='https://www.unotv.com/';
export const API_LOCAL='https://cdn.amxinfra.com/json/buscador/';
export const PAGESIZE=20;
export const MAX_RETRIES = 3; // Número máximo de reintentos
